import React from 'react';
import { useSpring, animated } from 'react-spring';
import Images from '../../constants/Images';
import { useTranslation } from 'react-i18next';
import './about.css';
import { Button } from 'react-bootstrap';

const About = () => {
    const { t } = useTranslation();

    const slide = useSpring({
        from: { transform: 'translateX(-100%)', opacity: 0 },
        to: { transform: 'translateX(0)', opacity: 1 },
        config: { duration: 500 }
    });

    const fade = useSpring({
        from: { opacity: 0 },
        to: { opacity: 1 },
        config: { duration: 1000 }
    });

    return (
        <div>
            <div className='section'>
                <div className="beneficiary">
                    <div className="overlay-text">{t('About')}</div>
                </div>
            </div>

            <section className="about_section layout_padding">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-5 col-md-6">
                            <animated.div className="detail-box" style={fade}>
                                <h2>{t('AboutCredix')}</h2>
                                <p>{t('CredixDescription')}</p>
                                <Button >{t("ReadMore")}</Button>
                            </animated.div>
                        </div>
                        <div className="col-lg-7 col-md-6">
                            <animated.div className="img-box" style={fade}>
                                <img src={Images.ChartPic} alt="About us" />
                            </animated.div>
                        </div>
                    </div>
                    <div className="row" style={{ marginTop: '100px' }}>

                        <div className="col-lg-7 col-md-6">
                            <animated.div className="img-box" style={fade}>
                                <img src={Images.Image1} alt="About Sanlam" />
                            </animated.div>
                        </div>
                        <div className="col-lg-5 col-md-6">
                            <animated.div className="detail-box" style={fade}>
                                <h2>{t('AboutSanlam')}</h2>
                                <p>{t("SanlamDescription")}</p>
                                <p>{t('SanlamDescriptionP2')}:</p>
                                <ul>
                                    <li>{t("SanlamDescriptionPointOne")}</li>
                                    <li>{t("SanlamDescriptionPointTwo")}</li>
                                </ul>

                                <Button >{t("ReadMore")}</Button>
                            </animated.div>
                        </div>

                    </div>
                    <div className="row" style={{ marginTop: '100px' }}>
                        <div className="col-lg-4">
                            <animated.div className="detail-box" style={fade}>
                                <h2>{t('AboutTechCare')}</h2>
                                <hr className='my-2' style={{ width: '40%', height: '2%', backgroundColor: 'green', marginBottom: '10px' }} />
                                <animated.img src={Images.ManHosp} className="img-box" alt="Techcare" style={{ width: '100%', height: '90%' }} />
                            </animated.div>
                        </div>
                        <div className="col-lg-8">
                            <animated.div className="detail-box" style={{ marginTop: '35px', ...fade }}>
                                <p className="">{t("TechCareDesc")}</p>
                                {/* <p>{t("TechCareDescP1")}:</p> */}
                                {/* <ul>
                                    <li>{t("TechCareDescPointOne")}</li>
                                    <li>{t("TechCareDescPointTwo")}</li>
                                    <li>{t("TechCareDescPointThree")}</li>
                                </ul> */}
                            </animated.div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default About;










// import React from 'react';
// import { useSpring, animated } from 'react-spring';
// import Images from '../../constants/Images';
// import { useTranslation } from 'react-i18next';
// import "./about.css"

// const About = () => {
//     const { t } = useTranslation();

//     const slide = useSpring({
//         from: { transform: 'translateX(-100%)', opacity: 0 },
//         to: { transform: 'translateX(0)', opacity: 1 },
//         config: { duration: 500 }
//     });

//     const fade = useSpring({
//         from: { opacity: 0 },
//         to: { opacity: 1 },
//         config: { duration: 1000 }
//     });

//     return (
//         <div>
//             <div className='section'>
//                 <div className="beneficiary">
//                     <div className="overlay-text">{t('About')}</div>
//                 </div>
//                 {/* <div className='cards'>
//                     <div className='card p-4'>
//                         <animated.div className='row' style={fade}>
//                             <div className='col-6 mb-4'>
//                                 <h5>{t('AboutCredix')}</h5>
//                                 <hr className='my-2' style={{ width: '20%', height: '2%', backgroundColor: 'green', marginBottom: '10px' }} />

//                                 <p className='about-text'>{t('CredixDescription')}</p>
//                             </div>
//                             <div className='col-6'>

//                                 <h5>{t('AboutSanlam')}</h5>
//                                 <hr className='my-2' style={{ width: '20%', height: '2%', backgroundColor: 'green', marginBottom: '10px' }} />

//                                 <p className='about-text'>{t('CredixDescription')}</p>
//                             </div>
//                         </animated.div>
//                         <div className='row'>
//                             <div className='col-4'>
//                                 <animated.h5 style={fade}>{t('AboutTechCare')}</animated.h5>
//                                 <hr className='my-2' style={{ width: '40%', height: '2%', backgroundColor: 'green', marginBottom: '10px' }} />
//                                 <animated.img src={Images.Image1} alt="Techcare" style={{ width: '100%', height: '90%' }} />
//                             </div>
//                             <div className='col-8'>
//                                 <animated.p style={{ marginTop: '35px', ...fade }} className="about-text">{t('CredixDescription')}</animated.p>
//                             </div>
//                         </div>
//                     </div>
//                 </div> */}
//             </div>

//             <section className="about_section layout_padding">
//                 <div className="container">
//                     <div className="row">
//                         <div className="col-lg-5 col-md-6">
//                             <div className="detail-box">
//                                 <h2>{t('AboutCredix')}</h2>
//                                 <p>
//                                     {t('CredixDescription')}
//                                                              </p>
//                                 <a href="">Read More</a>
//                             </div>
//                         </div>
//                         <div className="col-lg-7 col-md-6">
//                             <div className="img-box">
//                                 <img src="images/about-img.jpg" alt="About us" />
//                             </div>
//                         </div>
//                     </div>
//                     <div className="row" style={{ marginTop: '100px' }}>

//                         <div className="detail-box d-flex align-items-center justify-content-center m-4">
//                             <h2>{t('AboutSanlam')}</h2>

//                         </div>
//                         <div className="col-lg-7 col-md-6">
//                             <div className="img-box">
//                                 <img src={Images.Image1} alt="About us" />
//                             </div>
//                         </div>
//                         <div className="col-lg-5 col-md-6">
//                             <div className="detail-box">
//                                 {/* <h2>{t('AboutCredix')}</h2> */}
//                                 <p>
//                                     {t('CredixDescription')}</p>
//                                 <a href="">Read More</a>
//                             </div>
//                         </div>

//                     </div>
//                 </div>
//             </section>

//         </div>






//     );
// }

// export default About;
